// extracted by mini-css-extract-plugin
module.exports = {"card-set":"card-set_card-set__kOkOE","card-set-4":"card-set_card-set-4__yENC9","card-set-2":"card-set_card-set-2__i1KtE","card-set-3":"card-set_card-set-3__GoXIl"};